import React from 'react';
import { THEME } from '../../../../clearstep/util/Theme';
import PartnerLogo from '../../../../tailwind_clearstep/PartnerLogo/PartnerLogo';
// Because this is a single flow, we remove the "Back Button" wrapper to the header text
// User will use the launch button instead to return to collapsed greeting message
export var WidgetHeaderContentSingleFlow = function (props) {
    var _a;
    var headerText = props.headerText;
    var customTheme = ((_a = THEME.widgetCustomizations) === null || _a === void 0 ? void 0 : _a.widgetHeaderTheme) || {};
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mx-5" },
            React.createElement("span", { className: "text-xl font-medium text-primary" }, headerText)),
        React.createElement(PartnerLogo, { customLogoPath: customTheme.logoPath, enableLogoLink: false, imageClassName: "w-21.5 mr-4" })));
};
export default WidgetHeaderContentSingleFlow;
